// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wZQo","colMin":"styles_colMin__3ucKJ"};